import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectionService {
  private _data = new BehaviorSubject([]);

  get sharedData$(): Observable<any[]> {
    return this._data.asObservable();
  }

  // met à jour le subject
  stockData(_data: any) {
    this._data.next(_data);
  }

  // lit les données du subject
  get getData(): any {
    return this._data.getValue();
  }

  // ajoute un id à la sélection
  changeSelection(event: any, element: any, selKey: string) {
    let _data: any = this.getData;
    let _sel: any = _data[selKey] || [];

    // liste heures supp ou liste astreintes, suppression
    if (selKey == 'saisieHS' || selKey == 'saisieAst') {
      // stocke les ID
      if (event.checked) {
        _sel.push(element);
      } else {
        _sel = _sel.filter((v: any) => v.id != element.id);
      }
    }
    // liste de validation
    else {
      // pour une ligne d'un agent
      if (element['subTable'] != undefined && element['subTable'] != null && element['subTable'].length > 0) {
        let _subTable = element['subTable'];
        let _elements = _subTable.filter((ligne: any) => !ligne?.valider_hidden);

        // stocke les éléments
        if (event.checked) {
          _sel = [..._sel, ..._elements];
        } else {
          _elements.forEach((t: any) => {
            _sel = _sel.filter((v: any) => v.id != t.id);
          });
        }
      }
      // pour une seule ligne d'heures
      else {
        // stocke l'élément
        if (event.checked) {
          _sel.push(element);
        } else {
          _sel = _sel.filter((v: any) => v.id != element.id);
        }
      }
    }

    _data[selKey] = _sel;
    this.stockData(_data);
  }

  cocheToutSelection(_tableData: any[], selKey: string) {
    let _data: any = this.getData;
    delete _data[selKey];
    let _elements = this.extractDataElements(_tableData);
    _data[selKey] = _elements;

    this.stockData(_data);
  }

  resetSelection(selKey: any) {
    let _data: any = this.getData;
    delete _data[selKey];
    this.stockData(_data);
  }

  // recherche tous les éléments
  extractDataElements(_tableData: any[]) {
    let _elements: any = [];
    if (_tableData.length > 0) {
      _tableData.forEach((_ligne: any) => {
        // Si on a une subtable
        if (_ligne['subTable'] != undefined && _ligne['subTable'] != null && _ligne['subTable'].length > 0) {
          let _subTable = _ligne['subTable'];
          // si subtable contient des éléments (validation)
          let _items = _subTable.filter((li: any) => !li?.valider_hidden);
          _elements = [..._elements, ..._items];
        }
        // Si pas de subtable, on ajoute directement la ligne
        else {
          _elements.push(_ligne);
        }
      });
    }
    return _elements;
  }
}
